import dayjs, { Dayjs } from 'dayjs';

export function countDaysBetween(from: Dayjs, to: Dayjs) {
  return dayjs(from.format('YYYY-MM-DD')).diff(to.format('YYYY-MM-DD'), 'day');
}

/**
 *
 * @param date 날짜
 * @returns 요일을 return
 */
export function getDay(date: Dayjs) {
  const days = ['일', '월', '화', '수', '목', '금', '토'];
  return days[dayjs(date).day()];
}
